import styled from 'styled-components'

export const SwipeWrapper = styled.div``
